import { Grid } from "@material-ui/core"
import { Modal } from "App/Component/ui"
import { DEFAULT_BOX_SHADOW } from "App/constants"

import React, { useState, useEffect } from "react"

import {
  ModalSearchSEP,
  getDetailSepInEmr,
  getDetailSepInEmrByRencanaKontrol,
  getSearchSEP,
} from "../../../utils"
import { capitalizeFirst, defaultToastError, isNull } from "App/utils/helpers"
import { handleClickPrintSep, defaultStateSep } from "./helpers"
import { TabMasterSEP } from "./Tabs/TabMaster"
import KondisiMunculTableListNoRencanaKontrol from "./KondisiMunculTableListNoRencanaKontrol"
import TableListNoSEP from "../TableListRencanaKontrol/TableListNoSEP"
import { FormSEP } from "./FormSEP"
import { validasiTypeRegistrasi } from "../helpers"
import TableListSepSuplesi from "./TableListSepSuplesi/TableListSepSuplesi"
import ListRujukanKhusus from "./RawatJalan/ListRujukanKhusus"

function ModalSEP({
  setShowModal,
  pekerjaan,
  noRujukan,
  registrationID,
  type = "IGD",
  url = "/sep_regist/add_rigd",
  poliSEP,
  noSep,
  detailSep,
  noBPJS = "",
  tglLahir,
  jenisKelamin,
  patientID = "",
  tglKunjungan = "",
  noKontrol = "",
  handleChangeSep,
  typeNoRujukan = "pcare",
  dokterKodeBridge = "",
  dokterNama = "",
  updateRegistrasi,
}) {
  return (
    <Modal title={`SEP`} width="90%" show={setShowModal}>
      <ModalSEPContent
        pekerjaan={pekerjaan}
        noRujukan={noRujukan}
        registrationID={registrationID}
        type={type}
        url={url}
        poliSEP={poliSEP}
        noSep={noSep}
        detailSep={detailSep}
        noBPJS={noBPJS}
        tglLahir={tglLahir}
        jenisKelamin={jenisKelamin}
        patientID={patientID}
        tglKunjungan={tglKunjungan}
        noKontrol={noKontrol}
        handleChangeSep={handleChangeSep}
        typeNoRujukan={typeNoRujukan}
        dokterKodeBridge={dokterKodeBridge}
        dokterNama={dokterNama}
        updateRegistrasi={updateRegistrasi}
      />
    </Modal>
  )
}

export function ModalSEPContent({
  pekerjaan,
  noRujukan,
  registrationID,
  type = "IGD",
  url = "/sep_regist/add_rigd",
  poliSEP,
  noSep,
  detailSep,
  noBPJS = "",
  tglLahir,
  jenisKelamin,
  patientID = "",
  tglKunjungan = "",
  noKontrol = "",
  handleChangeSep,
  typeNoRujukan = "pcare",
  dokterKodeBridge = "",
  dokterNama = "",
  updateRegistrasi,
  isAlwaysShowModalSep = false,
  callbackHandleSetSep = () => {},
}) {

  const [formData, setFormData] = useState(
    defaultStateSep({
      detailSep,
      registrationID,
      type,
      pekerjaan,
      dokterNama,
      dokterKodeBridge,
      poliSEP,
      noBPJS,
      noRujukan,
      noKontrol,
      patientID,
    }),
  )

  const handleClickPrint = () => {
    handleClickPrintSep(
      {
        ...formData,
        tglLahir,
        patientID,
        jenisKelamin,
        pekerjaan,
      },
      type,
    )
  }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  React.useEffect(() => {
    setFormData(
      defaultStateSep({
        detailSep,
        registrationID,
        type,
        pekerjaan,
        dokterNama,
        dokterKodeBridge,
        poliSEP,
        noBPJS,
        noRujukan,
        noKontrol,
        patientID,
      }),
    )
  }, [registrationID])

  useEffect(() => {
    if (!isNull(noSep)) {
      ;(async () => {
        const response = await getDetailSepInEmr(noSep)
        if (response.state) {
          const responseEMR = response.data

          /** Validasi jika sep salah copas */
          const validasiType = validasiTypeRegistrasi.filter(
            (x) => x.sep === responseEMR.jnsPelayanan.toLowerCase(),
          )

          const jenisPelayanan = validasiTypeRegistrasi.filter(
            (x) => x.simrs === type.toLowerCase(),
          )

          const typeRegis = type.toLowerCase() === "ri" ? "ri" : "rj"

          if (validasiType[0].simrs === typeRegis) {
            const responseDetail = await getSearchSEP({
              nomor_kartu: responseEMR.peserta.noKartu,
              tgl_pelayanan: responseEMR.tglSep,
              type: "1",
            })

            const responseByRk = await getDetailSepInEmrByRencanaKontrol(noSep)
            if (responseDetail.state) {
              const ppkRujukanName =
                type === "RJ"
                  ? responseByRk.data.provPerujuk.nmProviderPerujuk
                  : responseDetail.data.peserta.provUmum.nmProvider

              const poliklinikSplit = responseByRk.data.poli.split(" - ")

              setFormData({
                ...formData,
                status: 1,
                no_kartu: responseEMR.peserta.noKartu,
                poli_tujuan_print: responseByRk.data.poli,

                nama_poliklinik: poliklinikSplit[1],
                kode_poliklinik: poliklinikSplit[0],

                // dpjp_layanan_kode: responseEMR.dpjp.kdDPJP,
                // dpjp_layanan_name: responseEMR.dpjp.nmDPJP,

                no_sep: noSep,
                hak_kelas: responseEMR.peserta.hakKelas,
                tgl_sep: responseEMR.tglSep,
                nama: responseEMR.peserta.nama,
                katarak: parseInt(responseEMR.katarak),
                nik: responseDetail.data.peserta.nik,
                no_tlp: responseDetail.data.peserta.mr.noTelepon,
                tgl_pelayanan: responseEMR.tglSep,
                catatan: responseEMR.catatan,
                laka_lantas: parseInt(responseEMR.kdStatusKecelakaan),
                // diagnosa_awal_name: responseEMR.diagnosa,
                diagnosa_awal_name: responseByRk?.data?.diagnosa,
                kls_rawat_naik_name: responseEMR.kelasRawat,
                ppk_rujukan_name: ppkRujukanName,
                pekerjaan: pekerjaan,
                no_rujukan: responseEMR.noRujukan,
                kls_rawat_hak: responseDetail.data.peserta.hakKelas.kode,
                tgl_rujukan: tglKunjungan,
                prolanisPRB:
                  responseDetail.data.peserta.informasi.prolanisPRB || null,
              })
            } else {
              defaultToastError(responseDetail.message)
            }
          } else {
            defaultToastError(
              `${noSep} merupakan sep ${
                responseEMR.jnsPelayanan
              }, gunakan sep ${capitalizeFirst(jenisPelayanan[0].sep)}`,
            )
          }
        } else {
          defaultToastError(response.message)
        }
      })()
    }
  }, [noSep]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSetSEP = (row) => {

    if (row.status === 1) {
      setFormData({
        ...formData,
        status: row.status,
        nama: row.peserta.nama,
        nik: row.peserta.nik,
        hak_kelas: row.peserta.hakKelas.keterangan,
        kode_hak_kelas: row.peserta.hakKelas.kode,

        no_tlp:  isNull(row?.peserta?.mr?.noTelepon) ? row?.nomor_telp??"" : row.peserta.mr.noTelepon,

        no_kartu: row.peserta.noKartu,
        tgl_pelayanan: row.tgl_pelayanan,
        pekerjaan: pekerjaan,

        // Langung ambil dari registrasi 05/08/22
        // no_rujukan: row.no_rujukan,

        poli_tujuan_print: row.poli_tujuan_print,
        ppk_rujukan_name: row.ppk_rujukan_name,
        ppk_rujukan_kode: row.ppk_rujukan_kode,

        // Langung ambil dari registrasi 08/08/22
        // Diubah ambil dari saat klik multi no rujukan
        tgl_rujukan: row.tgl_rujukan,

        kls_rawat_hak: row.peserta.hakKelas.kode,
        tgl_sep: row.tgl_pelayanan,

        /**
         * set diagnosa hanya jika dari rawat jalan
         */

        diagnosa_awal: type === "RJ" ? row.diagnosa_awal : "",
        diagnosa_awal_name: type === "RJ" ? row.diagnosa_awal_name : "",
        diagnosa_name: type === "RJ" ? row.diagnosa_awal : "",
        nokontrol: type === "RI" && isNull(formData.nokontrol) ? noRujukan : formData.nokontrol //set default no SPRI 
      })

      if (callbackHandleSetSep !== undefined) {
        callbackHandleSetSep(row)
      }
    }
  }

  /**
   * Perkondisian untuk menampilkan list no kontrol
   */

  const [showModalRencanaKontrol, setShowModalRencanaKontrol] = useState(false)
  const [rowsRencanaKontrol, setRowsRencanaKontrol] = useState([])
  const [rowsRencanaKontrolUtama, setRowsRencanaKontrolUtama] = useState([])

  const [showListSep, setShowListSep] = useState(false)
  const [showListSepSuplesi, setShowListSepSuplesi] = useState(false)
  const [showListRujukanKhusus, setShowListRujukanKhusus] = useState(false)

  const handleClickNoKontrol = () => {
    setShowModalRencanaKontrol(!showModalRencanaKontrol)
    setShowListSep(false)
    setShowListSepSuplesi(false)
    setShowListRujukanKhusus(false)
  }

  const handleClickNoRujukan = () => {
    setShowListSep(!showListSep)
    setShowModalRencanaKontrol(false)
    setShowListSepSuplesi(false)
    setShowListRujukanKhusus(false)
  }

  const handleClickSepSuplesi = () => {
    setShowListSepSuplesi(!showListSepSuplesi)
    setShowModalRencanaKontrol(false)
    setShowListSep(false)
    setShowListRujukanKhusus(false)
  }

  const handleClickRujukanKhusus = async () => {
    setShowListSepSuplesi(false)
    setShowModalRencanaKontrol(false)
    setShowListSep(false)
    setShowListRujukanKhusus(!showListRujukanKhusus)
  }

  /**
   * End
   */

  /**
   * Perkondisian
   */

  const [showModalMultiNoRujukan, setShowModalMultiNoRujukan] = useState(false)

  const handleClickMultiNoRujukan = () => {
    setShowModalMultiNoRujukan(!showModalMultiNoRujukan)
  }

  const handleClickSelectNoRujukanRawatInap = (row) => {
    setFormData({
      ...formData,
      no_rujukan: row.noSep,
    })
  }

  const handleClickSelectNoSepSuplesi = (row) => {
    setFormData({
      ...formData,
      nomor_sep_suplesi: row.noSep,
    })
  }

  const isShowModalSearchSep = isAlwaysShowModalSep
    ? true
    : isNull(noSep) && isNull(formData.nama)

  return (
    <>
      {isShowModalSearchSep && (
        <ModalSearchSEP
          patientID={patientID}
          handleSetSEP={handleSetSEP}
          noBPJS={noBPJS}
          noRujukan={noRujukan}
          type={type}
          typeNoRujukan={typeNoRujukan}
        />
      )}
      {formData.status === 1 && (
        <Grid
          container
          spacing={4}
          style={{
            // paddingBottom: "1rem",
            // paddingTop: "1rem",
            padding: isShowModalSearchSep ? "1rem 1rem" : "1rem 0",
          }}
        >
          <Grid
            item
            xs={6}
            style={{
              boxShadow: DEFAULT_BOX_SHADOW,
              borderRadius: 8,
            }}
          >
            <p
              style={{
                fontSize: "24px",
                fontWeight: "600",
              }}
            >
              {formData.nama}
            </p>
            <p
              style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "1rem",
              }}
            >
              No Kartu : {formData.no_kartu}
            </p>
            <div>
              {showModalRencanaKontrol ? (
                <>
                  <KondisiMunculTableListNoRencanaKontrol
                    setShowModal={() => setShowModalRencanaKontrol(false)}
                    formData={formData}
                    setFormData={setFormData}
                    rowsRencanaKontrol={rowsRencanaKontrol}
                    setRowsRencanaKontrol={setRowsRencanaKontrol}
                    rowsUtama={rowsRencanaKontrolUtama}
                    setRowsUtama={setRowsRencanaKontrolUtama}
                    isModal={false}
                    type={type}
                  />
                </>
              ) : showListSepSuplesi ? (
                <>
                  <TableListSepSuplesi
                    handleClickSelect={handleClickSelectNoSepSuplesi}
                    noBpjs={noBPJS}
                  />
                </>
              ) : showListRujukanKhusus ? (
                <>
                  <ListRujukanKhusus
                    showListRujukanKhusus={showListRujukanKhusus}
                  />
                </>
              ) : (
                <>
                  {showListSep ? (
                    <TableListNoSEP
                      handleClickSelect={handleClickSelectNoRujukanRawatInap}
                      noBpjs={noBPJS}
                    />
                  ) : (
                    <TabMasterSEP formData={formData} noBpjs={noBPJS} />
                  )}
                </>
              )}
            </div>
          </Grid>
          <FormSEP
            formData={formData}
            handleChange={handleChange}
            setFormData={setFormData}
            type={type}
            url={url}
            noKontrol={noKontrol}
            handleClickPrint={handleClickPrint}
            handleChangeSep={handleChangeSep}
            handleClickNoKontrol={handleClickNoKontrol}
            handleClickMultiNoRujukan={handleClickMultiNoRujukan}
            handleClickNoRujukan={handleClickNoRujukan}
            updateRegistrasi={updateRegistrasi}
            handleClickSepSuplesi={handleClickSepSuplesi}
            handleClickRujukanKhusus={handleClickRujukanKhusus}
          />
        </Grid>
      )}
    </>
  )
}

export default ModalSEP
